// import { storeMutations } from "../../mutations.constants";
const commonMutations = {};
export default { ...commonMutations };
